import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { FullScreenLoader } from "@/components/States";
import ProtectedRoute from "@/components/ProtectedRoute";

import Auth from "@/pages/Auth";
import DriveWithUs from "@/pages/DriveWithUs";
import Home from "@/pages/rider/Home";
import Ride from "@/pages/rider/Ride";
import RiderTrips from "@/pages/rider/Trips";
import RiderAccount from "@/pages/rider/Account";
import EditProfile from "@/pages/EditProfile";
import PaymentMethods from "@/pages/PaymentMethods";
import PaymentReturn from "@/pages/PaymentReturn";
import Inbox from "@/pages/Inbox";
import Chat from "@/pages/Chat";
import DriverDashboard from "@/pages/driver/Dashboard";
import DriverRides from "@/pages/driver/Rides";
import DriverTrip from "@/pages/driver/Trip";
import DriverEarnings from "@/pages/driver/Earnings";
import DriverAccount from "@/pages/driver/Account";
import AdminDashboard from "@/pages/admin/AdminDashboard";

function RootRedirect() {
  const { user, loading } = useAuth();
  if (loading) return <FullScreenLoader />;
  if (user?.role === "driver") return <Navigate to="/driver" replace />;
  if (user?.role === "admin") return <Navigate to="/admin" replace />;
  return <Home />;
}

export default function App() {
  const { loading } = useAuth();
  if (loading) return <FullScreenLoader />;
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<RootRedirect />} />
        <Route path="/auth" element={<Auth />} />
        <Route path="/drive-with-us" element={<DriveWithUs />} />

        {/* Rider */}
        <Route path="/ride/:id" element={<ProtectedRoute role="customer"><Ride /></ProtectedRoute>} />
        <Route path="/trips" element={<ProtectedRoute role="customer"><RiderTrips /></ProtectedRoute>} />
        <Route path="/account" element={<ProtectedRoute role="customer"><RiderAccount /></ProtectedRoute>} />
        <Route path="/inbox" element={<ProtectedRoute><Inbox /></ProtectedRoute>} />
        <Route path="/chat/:id" element={<ProtectedRoute><Chat /></ProtectedRoute>} />
        <Route path="/edit-profile" element={<ProtectedRoute><EditProfile /></ProtectedRoute>} />
        <Route path="/payment-methods" element={<ProtectedRoute><PaymentMethods /></ProtectedRoute>} />
        <Route path="/payment-return" element={<ProtectedRoute><PaymentReturn /></ProtectedRoute>} />

        {/* Driver */}
        <Route path="/driver" element={<ProtectedRoute role="driver"><DriverDashboard /></ProtectedRoute>} />
        <Route path="/driver/rides" element={<ProtectedRoute role="driver"><DriverRides /></ProtectedRoute>} />
        <Route path="/driver/trips" element={<ProtectedRoute role="driver"><DriverEarnings /></ProtectedRoute>} />
        <Route path="/driver/inbox" element={<ProtectedRoute role="driver"><Inbox /></ProtectedRoute>} />
        <Route path="/driver/account" element={<ProtectedRoute role="driver"><DriverAccount /></ProtectedRoute>} />
        <Route path="/driver-trip/:id" element={<ProtectedRoute role="driver"><DriverTrip /></ProtectedRoute>} />

        {/* Admin */}
        <Route path="/admin/*" element={<ProtectedRoute role="admin"><AdminDashboard /></ProtectedRoute>} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
